import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import AssociationSingleAutocompleteBoxViewModelType from '@/ViewModels/Controls/AssociationSingleAutocompleteBoxViewModel';
import LinkType from '@/Controls/Link';
import MultiSelectAutoCompleteType from '@/Controls/MultiSelectAutoComplete';
import HiddenType from '@/Controls/Hidden';

export default class AssociationSingleAutocompleteBox extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private MultiSelectAutoComplete = ComponentManager.getControl<typeof MultiSelectAutoCompleteType>('MultiSelectAutoComplete');
    private Hidden = ComponentManager.getControl<typeof HiddenType>('Hidden');

    public multiSelectAutoComplete: MultiSelectAutoCompleteType;
    public hidden: HiddenType;
    public linkCreate: LinkType;
    public linkSelect: LinkType;
    public linkEdit: LinkType;
    public linkDisconnect: LinkType;
    public linkDelete: LinkType;

    private jQueryControl: JQuery;

    public constructor(private viewModel: AssociationSingleAutocompleteBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationsingleautocompletebox',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];
                    if (this.viewModel.isRequired() === true) states.push('required');
                    if (this.viewModel.isValid() === true) states.push('valid');
                    if (this.viewModel.isValid() !== true) states.push('invalid');
                    if (this.viewModel.isEnabled() === true) states.push('enabled');
                    if (this.viewModel.isEnabled() !== true) states.push('disabled');

                    return states;
                }
            })
        });

        this.createSubControl(this.MultiSelectAutoComplete, this.viewModel.multiSelectAutoComplete, 'multiSelectAutoComplete');
        this.createSubControl(this.Hidden, this.viewModel.hidden, 'hidden');
        this.createSubControl(this.Link, this.viewModel.linkCreate, 'linkCreate');
        this.createSubControl(this.Link, this.viewModel.linkSelect, 'linkSelect');
        this.createSubControl(this.Link, this.viewModel.linkEdit, 'linkEdit');
        this.createSubControl(this.Link, this.viewModel.linkDisconnect, 'linkDisconnect');
        this.createSubControl(this.Link, this.viewModel.linkDelete, 'linkDelete');
    }

    private createSubControl<T extends typeof Control>(type: T, viewModel, propertyId: keyof this) {
        if (viewModel == null) {
            return;
        }

        this[propertyId as string] = new type(viewModel);
        (this[propertyId as string] as Control).getTuple().control.appendTo(this.jQueryControl);
    }

    public addLabelReference(label: JQuery): JQuery {
        return this.multiSelectAutoComplete.addLabelReference(label);
    }
}

ComponentManager.setControl('AssociationSingleAutocompleteBox', AssociationSingleAutocompleteBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');